module.exports = __webpack_public_path__ + "static/media/penguin_aukee.d50b0acb.png";